// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#pgrid-root-container{margin-top:3px;margin-left:8px}", "",{"version":3,"sources":["webpack://./src/lib/pgrid/pgrid-root-app.vue"],"names":[],"mappings":"AAAA,sBAAsB,cAAc,CAAC,eAAe","sourcesContent":["#pgrid-root-container{margin-top:3px;margin-left:8px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
